import { TableCellRenderer } from "react-table";

import * as globalTableColumns from "src/core/shared/components/TableGlobalColumns";

export const customersTableColumns = (ActionButton: TableCellRenderer) => {
  return [
    globalTableColumns.id(),
    globalTableColumns.standardText({
      Header: "Acc. Number",
      accessor: "accountNumber",
      width: 100
    }),
    globalTableColumns.standardText({
      Header: "Name",
      accessor: "name",
      width: 250
    }),
    globalTableColumns.standardText({
      Header: "Address",
      accessor: "address.addressLine1",
      sortable: false
    }),
    globalTableColumns.customerDropStatus(),
    globalTableColumns.actions({ cell: ActionButton })
  ];
};
